import React from 'react';
import ArrowUpSvg from 'assets/icons/arrow-up.svg';
import {COLORS} from 'constants/index';

interface IArrowUpProps extends React.SVGAttributes<SVGElement> {
    color?: string;
}

const ArrowUpIcon: React.FC<IArrowUpProps> = ({color = COLORS.PRIMARY40, ...rest}) => (
	<ArrowUpSvg {...rest} style={{color}} role='button' />
);

export default ArrowUpIcon;
